import { clsx } from 'clsx';
import {
  EntityDisplayConfig,
  EntityDisplayConfigField
} from '../../../interfaces/entity-display-config';
import { EntityDisplayConfigLabel } from '../EntityDisplayConfigLabel/EntityDisplayConfigLabel';
import { EntityDisplayConfigValue } from '../EntityDisplayConfigValue/EntityDisplayConfigValue';
import styles from './EntityDisplayConfigReview.module.scss';

export function EntityDisplayConfigReview({
  displayConfig,
  className,
  showDiffMode,
  canUseDiffModeStyles
}: {
  displayConfig: EntityDisplayConfig;
  className?: string;
  showDiffMode?: boolean;
  canUseDiffModeStyles?: (field: EntityDisplayConfigField) => boolean;
}) {
  const canShowDiffMode = showDiffMode && displayConfig.hasDiff;

  const getFieldStyles = (field: EntityDisplayConfigField) => {
    return (canShowDiffMode && field.previousValue !== field.value) ||
      (canUseDiffModeStyles && canUseDiffModeStyles(field))
      ? styles.entityDisplayCfgRvwDiff
      : styles.entityDisplayCfgRvwSame;
  };

  return (
    <div className={clsx('flex-col mt-5 ml-3', className)}>
      {canShowDiffMode ? (
        <div className='center-flex-row border-bottom pb-2 mb-3'>
          <span className={clsx('w-40', styles.entityDisplayCfgRvwHeaderProp)}>Property</span>

          <span className={clsx('w-30', styles.entityDisplayCfgRvwHeaderProp)}>New Value</span>

          <span className={clsx('w-30', styles.entityDisplayCfgRvwHeaderProp)}>Previous Value</span>
        </div>
      ) : null}

      {displayConfig.fields.map(field => (
        <div className={clsx('center-flex-row mb-5 w-100')} key={field.name}>
          <EntityDisplayConfigLabel
            field={field}
            containerClassName={clsx(canShowDiffMode ? 'w-40' : 'w-50')}
            className={getFieldStyles(field)}
          />

          <EntityDisplayConfigValue
            field={field}
            containerClassName={clsx(canShowDiffMode ? 'w-30' : 'w-50')}
            className={getFieldStyles(field)}
            showHelperText={false}
          />

          {canShowDiffMode ? (
            <EntityDisplayConfigValue
              field={field}
              containerClassName='w-30'
              className={getFieldStyles(field)}
              showHelperText={false}
              usePreviousValue
            />
          ) : null}
        </div>
      ))}
    </div>
  );
}
